
import React, { useEffect,useState } from 'react';
import { Layout, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch, DatePicker, Divider, Upload } from 'antd';
import { FormOutlined, SendOutlined, DeleteOutlined,UploadOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, appIdentifier, dateFormat, deleteDataWithToken, editDataWithToken, getDataWithToken, getLocal, globalUrlBare } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
import moment from 'moment';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ارسال البحوث للتدريسيين';

const  MngSendToTeacher = ()=> {
    const navigate = useNavigate();
    const [addInfoForm] = Form.useForm()
    const [editInfoForm] = Form.useForm()

    const [addInfoVisible, setAddInfoVisible] = useState(false);
    const [editInfoVisible, setEditInfoVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [infoFormInfo, setInfoFormInfo] = useState(null)
    const [infos, setInfos] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const [certificates, setcertificates] = useState([])
    const [scintificTitles, setscintificTitles] = useState([])
    const localUserType = getLocal(appIdentifier)?.user?.user_type || null 

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getInfos(current,pageSize)
      };


      const onAddClose = () => {
        setAddInfoVisible(false);
        setSelectedInfo(null)
        addInfoForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditInfoVisible(false);
        setSelectedInfo(null)
        editInfoForm.resetFields()
        
      };

   
   

      const getInfos = (current=1,pageSize=25)=>{
        setAddLoading(true)
        getDataWithToken(`teachers?pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setInfos(result?.data);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const getCertificates = (current=1,pageSize=25)=>{
        getDataWithToken(`certificates`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setcertificates(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const getScintificTitles = ()=>{
        getDataWithToken(`scintific-titles`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setscintificTitles(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const addInfo = (data)=>{
        console.log('data isss', data)
        setAddLoading(true)
        addDataWithToken(`teachers/send_thesis`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم ارسال البحث  بنجاح');
            getInfos();
            addInfoForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                deleteDataWithToken(`infos/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف التدريسي بنجاح');
                            getInfos();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareEdit = (data)=>{
            console.log('data iss', data)
            setSelectedInfo(data)
           
            setAddInfoVisible(true)
        }

        const editInfo = (data)=>{
         
            setAddLoading(true);
            editDataWithToken(`infos/${selectedInfo?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل التدريسي بنجاح');
                        getInfos();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
       getInfos();
       getCertificates();
       getScintificTitles();
      }, [])

      

      const token = getLocal(appIdentifier)?.jwt ; 

      
      
      const [files,setFiles] = useState()

      const uploadImage = async (e) => {
       
        const token = getLocal(appIdentifier)?.jwt ; 

        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);

        var formdata = new FormData();
        formdata.append('files', files[0])
        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };

        fetch(`${globalUrlBare}/api/upload`, requestOptions)
        .then(response => response.json())
        .then(result => {
            addInfo({...e,sender_attachment:result?.[0]?.id})
            
        })
        .catch(error => console.log('error', error));
    }
    
    
    return(
        <Layout className='mainContainer'>
             <Drawer
                title={` ارسال مستند الى التدريسي ( ${selectedInfo?.teacher_name} )  `}
                placement="left"
                closable={false}
                onClose={onAddClose}
                visible={addInfoVisible}
                width={window.innerWidth > 900 ? 700 :  350}
            >
                <Form 
                    form={addInfoForm} 
                    onFinish={uploadImage}
                    onValuesChange={(changedValues,allValues)=>{
                        setInfoFormInfo(allValues);
                    }}
                    layout='inline'
                >

                    <Form.Item  
                        className='myFormItem' 
                        name="id" 
                        hidden
                        initialValue={selectedInfo?.id}
                        >
                             
                    </Form.Item>
                    <Form.Item  
                        className='myFormItem' 
                        name="email" 
                        hidden
                        initialValue={selectedInfo?.email}
                        >
                             
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="name" 
                        hidden
                        initialValue={selectedInfo?.teacher_name}
                        >
                             
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="student_name" 
                        label="اسم الطالب"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم الطالب',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم الطالب"  style={{minWidth:250}}  />
                    </Form.Item>

                    


                     <Form.Item  
                        className='myFormItem' 
                        name="title" 
                        label="عنوان الرسالة \ الاطروحة"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة عنوان الرسالة / الاطروحة',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="عنوان الرسالة / الاطروحة"  style={{minWidth:250}}  />
                    </Form.Item>

                    

                    <Form.Item    
                    className='myFormItem'
                    name="student_certificate" 
                    rules={[{ required: true, message: 'يرجى اختيار الشهادة ' }]}
                    label="الشهادة"
                    >
                        <Select size="large"  placeholder="الشهادة" style={{minWidth:250}}>
                            {
                                [{title:'الماجستير', value:'master'},{title:'الدكتوراه', value:'doctor'}]?.map(({value,title},index) => {
                                    return(<Option value={value} key={value} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="dissertation_general_sepcialization" 
                        label="الاختصاص العام للرسالة \ الاطروحة"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاختصاص العام للرسالة / الاطروحة"',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاختصاص العام للرسالة \ الاطروحة" style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item  
                        className='myFormItem' 
                        name="dissertation_specific_sepcialization" 
                        label="الاختصاص الدقيق للرسالة \ الاطروحة"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاختصاص الدقيق للرسالة / الاطروحة"',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاختصاص الدقيق للرسالة \ الاطروحة" style={{minWidth:250}}  />
                    </Form.Item>

                    <Form.Item 
                        name='sender_attachment' 
                        label="ملف الرسالة \ الاطروحة"  
                        // getValueFromEvent={getFileForSender}
                        className='myFormItem' 
                        rules={[
                            {
                              required: true,
                              message: 'يرجى اختيار ملف الرسالة / الاطروحة"',
                            }
                          ]}
                        >
                            <input 
                                type="file"
                                onChange={(e)=>setFiles(e.target.files)}
                            />
                        {/* <Upload {...uploadProps} >
                            <Button icon={<UploadOutlined />}>Select File</Button>
                        </Upload> */}
                    </Form.Item>

                </Form>
                


                <Button  style={{backgroundColor:Colors.primary, borderWidth:0, marginRight:10}}  type="primary"  icon={<SendOutlined />} onClick={()=>{addInfoForm.submit()}} loading={false} >
                          ارسال الطلب
                </Button>

                
            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'mngSendToTeacher'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={infos}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                    >

                    

                        <Column title="اسم التدريسي"  width="200px" key="teacher_name" fixed="left" dataIndex="teacher_name" />

                        <Column title="الشهادة"  width="200px" key="certificate" 
                            render={(text, record) => (
                                <Space>
                                    {record?.certificate?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الاختصاص"  width="200px" key="specialization" dataIndex="specialization" />

                        <Column title="الاختصاص الدقيق"  width="200px" key="delicate_specialization" 
                            render={(text, record) => (
                                <Space>
                                    {record?.delicate_specialization}
                                </Space>
                                
                            )}
                        />

                        <Column title="اللقب العلمي"  width="200px" key="scintific_title" 
                            render={(text, record) => (
                                <Space>
                                    {record?.scintific_title?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الجامعة"  width="200px" key="university" 
                            render={(text, record) => (
                                <Space>
                                    {record?.university?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الكلية"  width="200px" key="college" 
                            render={(text, record) => (
                                <Space>
                                    {record?.college?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="القسم"  width="200px" key="depart" 
                            render={(text, record) => (
                                <Space>
                                    {record?.depart?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="البريد الالكتروني"  width="200px" key="email"  dataIndex="email" />
                        <Column title="رقم الهاتف"  width="200px" key="phone"  dataIndex="phone" />
                        <Column title="تاريخ الميلاد"  width="200px" key="birthdate" dataIndex="birthdate" />
                        <Column title="عدد طلبة الدبلوم"  width="200px" key="diplom_stu" dataIndex="diplom_stu" />
                        <Column title="عدد طلبة الماجستير"  width="200px" key="master_stu" dataIndex="master_stu" />
                        <Column title="عدد طلبة الدكتوراه"  width="200px" key="phd_stu" dataIndex="phd_stu" />
                        <Column title="رقم كتاب المباشرة في القسم"  width="200px" key="start_no" dataIndex="start_no" />
                        <Column title="تاريخ كتاب المباشرة في القسم"  width="200px" key="start_date" dataIndex="start_date" />
                        <Column title="تاريخ اخر تعديل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { moment(record?.updatedAt).format(dateFormat) }
                                </Space>
                                
                            )}
                        />
                        <Column title="تم التعديل من قبل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { record?.admin?.fname||''}
                                </Space>
                                
                            )}
                        />

                        
                        {
                            localUserType==='depart'&&
                            
                            <Column title="العمليات"  width="200px" key="status" 
                                fixed='right'
                                render={(text, record) => (
                                    <Space>
                                    <Button onClick={()=> prepareEdit({id:record?.id,...record}) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<FormOutlined />} size={20}>
                                        ارسال مستند للتقييم
                                    </Button>

                                   
                                    </Space>
                                    
                                )}
                            />

                        }
                         
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngSendToTeacher




